// material ui icons
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
// * Icons
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';

// material ui
import { Avatar, Badge, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';

// components
import holiday_village from '@/assets/icons/holiday_village.svg';

const EnergyGroupTypeAvatar = ({ type }) => {
  const isPortfolio = type && type.startsWith('Portfolio');
  const baseEnergyKey = (type || 'Power').replace(/^Portfolio/, '');
  const paletteKey = baseEnergyKey.toLowerCase();
  const theme = useTheme();

  const EnergyIcon =
    baseEnergyKey === 'Power'
      ? BoltRoundedIcon
      : baseEnergyKey === 'Heat'
        ? LocalFireDepartmentRoundedIcon
        : baseEnergyKey === 'Water'
          ? WaterDropRoundedIcon
          : baseEnergyKey === 'Buildings'
            ? ApartmentRoundedIcon
            : null;

  return (
    <Avatar
      variant="rounded"
      sx={(theme) => ({
        borderRadius: 2,
        height: 24,
        width: 24,
        p: 0.5,
        mr: 1,
        transition: 'all 0.3s',
        backgroundColor: alpha(
          theme.palette[paletteKey]?.main || theme.palette.primary.main,
          0.15,
        ),
        color: isPortfolio
          ? theme.palette.text.secondary
          : theme.palette[paletteKey]?.main || theme.palette.primary.main,
      })}
    >
      {isPortfolio && EnergyIcon ? (
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            <EnergyIcon
              sx={(theme) => ({
                fontSize: 16,
                color:
                  theme.palette[paletteKey]?.main || theme.palette.primary.main,
              })}
            />
          }
        >
          <img
            src={holiday_village}
            alt="portfolio"
            style={{
              filter:
                theme.palette.mode === 'dark' ? 'invert(25%)' : 'invert(60%)',
            }}
          />
        </Badge>
      ) : EnergyIcon ? (
        <EnergyIcon fontSize="small" />
      ) : null}
    </Avatar>
  );
};

export default EnergyGroupTypeAvatar;
